import React from 'react';


interface Feature {
  id: number;
  icon: string;
  title: string;
  description: string;
  gradient: string;
}

const FeaturesGrid = () => {
  const features: Feature[] = [
  {
    id: 1,
    icon: "BoltIcon",
    title: "Lightning Fast",
    description: "Sub-200ms response times with edge computing. Your customers won't wait.",
    gradient: "from-yellow-400 to-orange-500"
  },
  {
    id: 2,
    icon: "ShieldCheckIcon",
    title: "Enterprise Security",
    description: "SOC 2 Type II, GDPR compliant. Bank-grade encryption for all conversations.",
    gradient: "from-green-400 to-emerald-600"
  },
  {
    id: 3,
    icon: "GlobeAltIcon",
    title: "40+ Languages",
    description: "Native support for global markets. Understand context and nuance perfectly.",
    gradient: "from-blue-400 to-indigo-600"
  },
  {
    id: 4,
    icon: "ChartBarIcon",
    title: "Real-time Analytics",
    description: "Deep insights into every conversation. Optimize performance continuously.",
    gradient: "from-purple-400 to-pink-600"
  },
  {
    id: 5,
    icon: "PuzzlePieceIcon",
    title: "Easy Integration",
    description: "Connect to 100+ platforms. RESTful APIs and pre-built SDKs included.",
    gradient: "from-cyan-400 to-blue-600"
  },
  {
    id: 6,
    icon: "CpuChipIcon",
    title: "Advanced AI",
    description: "98% accuracy with GPT-4 powered understanding. Learns from every interaction.",
    gradient: "from-red-400 to-rose-600"
  }];


  return;
















































};

export default FeaturesGrid;